import styled from "styled-components";
import YouTube from "react-youtube";
import { count } from "console";

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 578px;
  background-color: #1f2d3d;
  width: 100%;
  position: relative;

  @media screen and (max-width: 768px) {
    height: auto;
    padding-top: 64px;
    padding-bottom: 48px;
  }
`;

export const BrushContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;

  img {
    width: 100%;
    object-fit: contain;
  }
`;

export const BodyWrapper = styled.div`
  margin: auto;
  width: 1016px;
  position: relative;
  z-index: 1;
`;

export const Section = styled.div`
  padding: 0 16px;
`;

export const Title = styled.h1`
  font-size: 36px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  color: #f0f2f9;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

export const SingleVideoWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  width: 100%;
  padding-top: 32px;

  .media-player iframe {
    width: 100%;
    height: 274px;
    border-radius: 12px;
  }
`;

export const CardVideo = styled.div<{ count: number }>`
  width: ${({ count }) => (count === 1 ? "50%" : "100%")};
  height: 274px;
  border-radius: 12px;
  background-color: grey;
`;

export const CardContent = styled.div<{ count: number }>`
  width: ${({ count }) => (count === 1 ? "50%" : "100%")};
  height: ${({ count }) => (count === 1 ? "274px" : "auto")};
  display: flex;
  flex-direction: column;
  justify-content: ${({ count }) => (count === 1 ? "center" : "flex-start")};
  overflow-y: hidden;
  row-gap: ${({ count }) => (count === 1 ? "4px" : "0")};
`;

export const VideoTitle = styled.h1`
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin: 0;
`;

export const VideoDescription = styled.p`
  font-size: 16px;
  color: #fff;
  margin: 0;
  padding: 0;
`;

export const DoubleVideoWrapper = styled.div`
  display: flex;
  column-gap: 32px;
  width: 100%;
  padding-top: 32px;

  .media-player iframe {
    width: 100%;
    height: 274px;
    border-radius: 12px;
  }
`;

export const CardDouble = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  height: auto;
  overflow-y: hidden;
`;

export const MultipleVideoWrapper = styled.div`
  margin: auto;
  padding-top: 32px;
  width: 1160px;
  z-index: 1;

  .section-title {
    padding-left: 64px;
    padding-bottom: 32px;
  }
`;

export const MultipleVideoCard = styled.div`
  width: 328px;
  height: auto;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  row-gap: 4px;

  .media-player iframe {
    width: 100%;
    height: 181px;
    border-radius: 12px;
  }
`;

export const MutltipleCardVideo = styled.div`
  width: 324px;
  height: 181px;
  border-radius: 12px;
  background-color: grey;
`;

export const MultipleCardContent = styled.div`
  width: 324px;
  height: 75px;
  overflow-y: hidden;
`;

export const MultipleVideoTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  margin: 0;
  padding: 0;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
`;

export const MultipleVideoDescription = styled.p`
  font-size: 14px;
  color: #fff;
  margin: 0;
  padding: 0;
  /* Add these missing properties */
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  position: relative;
  top: -2px;
`;

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding-left: 20px;
  position: relative;
  z-index: 1;
  overflow-x: auto;
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  column-gap: 20px;
  overflow-x: scroll;
  padding-right: 20px;
  scroll-behavior: smooth;
  width: auto;
`;
